<div class="wrapper">
  <div class="close-wrapper">
    <span class="close-mobile-sidebar" (click)="showRightSidebar.set(false)">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18" stroke="#003765" stroke-width="2" stroke-linejoin="round"/>
        <path d="M6 6L18 18" stroke="#003765" stroke-width="2" stroke-linejoin="round"/>
      </svg>
    </span>
  </div>

  <h3 class="user-name">{{givenName}} {{familyName}}</h3>
  <p class="user-email">{{userEmail}}</p>
  <p class="user-phone">+{{userPhone}}</p>

  <p class="change-account-label">{{'checkResult.changeAccountInfoLabel' | transloco}}</p>

  <div class="min-user-card">
    <div class="user-info-wrapper">
      <span class="user-avatar">{{givenName[0]}}{{familyName[0]}}</span>
      <span class="user-name-info">{{givenName}} {{familyName}}</span>
    </div>

    <span class="user-type">Primary</span>

    <button routerLink="/results/category" (click)="showRightSidebar.set(false)" class="visit-button">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.99967 3.33398L8.82468 4.50898L13.4747 9.16732H3.33301V10.834H13.4747L8.82468 15.4923L9.99967 16.6673L16.6663 10.0007L9.99967 3.33398Z" fill="white"/>
      </svg>
    </button>
  </div>

  @for (ward of wards$ | async; track $index) {
    <div class="min-user-card">
      <div class="user-info-wrapper">
        <span class="user-avatar">{{ward.firstName[0]}}{{ward.lastName[0]}}</span>
        <span class="user-name-info">{{ward.firstName}} {{ward.lastName}}</span>
      </div>

      <span class="user-type">Ward</span>

      <button (click)="wardSwitch(ward.id_mpi)" class="visit-button">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.99967 3.33398L8.82468 4.50898L13.4747 9.16732H3.33301V10.834H13.4747L8.82468 15.4923L9.99967 16.6673L16.6663 10.0007L9.99967 3.33398Z" fill="white"/>
        </svg>
      </button>
    </div>
  }

  <ul class="links-wrapper">
    <li>
      <a [href]="baseProfileUrl">
        <span>{{ 'resultsV2.accountPreferences' | transloco }}</span>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18L15 12L9 6" stroke="#0077AD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>
    </li>
    <li>
      <a href="javascript:;" (click)="logout()">
        <span>{{ 'header.logoutLabel' | transloco }}</span>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18L15 12L9 6" stroke="#0077AD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>
    </li>
  </ul>
</div>
